import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunkMiddleware from 'redux-thunk';
import { authReducer } from "./reducers/FrontendReducers/authenticationReducer";
import { blogReducer } from "./reducers/FrontendReducers/blogReducers";
import { messageReducer } from "./reducers/FrontendReducers/MessageReducer";
import { OrderReducer } from "./reducers/FrontendReducers/OrderReducer";
import { portfolioReducer } from "./reducers/FrontendReducers/portfolioReducers";
import { pricingReducer } from "./reducers/FrontendReducers/pricingReducer";
import { resumeReducer } from "./reducers/FrontendReducers/resumeReducer";
import { viwerReducer } from "./reducers/FrontendReducers/viewerReducer";


const rootReducer = combineReducers({
     Auth : authReducer,
     Blog: blogReducer,
     Resume:resumeReducer,
     Portfolio: portfolioReducer,
     Message: messageReducer,
     Pricing: pricingReducer,
     View: viwerReducer,
     Order:OrderReducer
  
})


const middleware = [thunkMiddleware];

const store = createStore(rootReducer,compose(
   applyMiddleware(...middleware),
     // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
));

export default store;
